/* global axios */
import ApiClient from './ApiClient';

// Kanban por etiqueta CLT: 1 chamada devolve todas as colunas (contagem real +
// primeiros cards, mais recentes primeiro); "Carregar mais" pagina UMA coluna.
// v172: board exige CAIXA; filtros data/modo/fechadas/time/agente; /filtros
// devolve os seletores permitidos pro papel do usuário.
class KanbanApi extends ApiClient {
  constructor() {
    super('kanban', { accountScoped: true });
  }

  buildParams({ inboxId, data, modoData, fechadas, teamId, assigneeId } = {}) {
    return {
      inbox_id: inboxId || undefined,
      data: data || undefined,
      modo_data: data ? modoData || undefined : undefined,
      fechadas: fechadas ? '1' : undefined,
      team_id: teamId || undefined,
      assignee_id: assigneeId || undefined,
    };
  }

  getFiltros() {
    return axios.get(`${this.url}/filtros`);
  }

  getBoard(filtros = {}) {
    return axios.get(this.url, { params: this.buildParams(filtros) });
  }

  getColumn({ label, offset, ...filtros }) {
    return axios.get(this.url, {
      params: { label, offset, ...this.buildParams(filtros) },
    });
  }
}

export default new KanbanApi();
